import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { BulkWithdrawalsOverviewKey } from 'api/Wallet/Types/BulkWithdrawalsOverviewDto'
import { Link } from 'components/Link'
import { links } from 'utils/featureToggles'

import './Create/transaction.scss'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const transactionBulkTransactionWithdrawalsHistoryColumn: GridColumn[] = [
  {
    width: 150,
    title: 'Reference',
    field: BulkWithdrawalsOverviewKey.name,
    show: true,
    cell: (gridCellProps: GridCellProps): JSX.Element => {
      if (!gridCellProps.dataItem.name) {
        return <td />
      }
      const urlSearchParams = new URLSearchParams()
      urlSearchParams.set('groupReference', gridCellProps.dataItem.name)
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline', cursor: 'pointer' }}>
          <Link
            state={{ redirectTo: links.transactionBulkWithdrawals.url }}
            to={{
              pathname: links.transactionDepositWithdrawal.url,
              search: `?${urlSearchParams.toString()}`,
            }}
          >
            {gridCellProps.dataItem.name}
          </Link>
        </td>
      )
    },
  },
  {
    title: '# of Transactions',
    field: BulkWithdrawalsOverviewKey.allTransactions,
    show: true,
  },
  {
    title: '# of Completed Transactions',
    field: BulkWithdrawalsOverviewKey.completedTransactions,
    show: true,
  },
  {
    title: '# of Declined Transactions',
    field: BulkWithdrawalsOverviewKey.declinedTransactions,
    show: true,
  },
  {
    title: '# of Failed Transactions',
    field: BulkWithdrawalsOverviewKey.failedTransactions,
    show: true,
  },
  {
    title: 'Date Created',
    field: BulkWithdrawalsOverviewKey.dateCreated,
    show: true,
    resizable: true,
    filter: 'text',
  },
  {
    title: 'Date Updated',
    field: BulkWithdrawalsOverviewKey.dateUpdated,
    show: true,
    resizable: true,
    filter: 'text',
  },
]
